import { getQuestionEventsMetadata } from "./common";

const GA_CATEGORY_NAME = 'Question answered';

const questionAnsweredEvents = {
  questionAnswered: {
    eventName: 'Question Answered',
    getMetaData: ({
      cancerType,
    }) => getQuestionEventsMetadata(cancerType),
  },
};

export {
  GA_CATEGORY_NAME,
};

export default questionAnsweredEvents;
